import { Navigate } from 'react-router-dom';
import { useMe } from '../hooks/useAuth.js';

export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useMe();
  if (isLoading) {
    return <div className="mx-auto max-w-md px-4 py-24 text-center text-navy-500">Loading…</div>;
  }
  if (!data?.user) {
    return <Navigate to="/login?next=/admin" replace />;
  }
  if (!data.user.roles.includes('admin')) {
    return (
      <div className="mx-auto max-w-md px-4 py-24 text-center">
        <h1 className="text-2xl font-bold text-navy mb-2">Admin only</h1>
        <p className="text-navy-600">Your account doesn't have admin access.</p>
      </div>
    );
  }
  return <>{children}</>;
}
